<template>
  <div>
    <div class="position-fixed top-0 end-0 end-md-15px end-lg-30px w-100 mt-80px mt-lg-100px px-15px px-md-0 w-md-auto" style="z-index: 2000;">
      <div ref="report" class="toast w-100 w-md-350px" role="alert" aria-live="polite" aria-atomic="true">
        <div class="toast-body bg-success text-white rounded fs-6 text-start">
          Ďakujeme za nahlásenie problému alebo nevhodného textu!

          <div class="mt-5px">
            <span class="text-white text-decoration-underline" data-bs-dismiss="toast" aria-label="Zavrieť hlášku" style="font-size: .875rem; cursor: pointer;">
              Zavrieť
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown">
      <button role="button" :class="buttonClass" id="reportButton" data-bs-toggle="dropdown" aria-expanded="false" title="Nahlásiť">
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" class="bi bi-exclamation-circle-fill lh-1" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
        </svg>

        <span v-if="!iconOnly" class="fs-sm ms-5px">Nahlásiť</span>
      </button>

      <div class="dropdown-menu p-15px" :class="{'dropdown-menu-end': side === 'end', 'dropdown-menu-start': side === 'start'}" aria-labelledby="reportButton">
        <textarea class="form-control" v-model="text" :name="id" :id="id" cols="30" rows="3" style="min-width: 300px;" placeholder="Popíš nevhodný obsah..."></textarea>
        <button type="button" class="btn btn-danger fs-sm mt-5px" @click="createReport">Nahlásiť</button>
      </div>
    </div>
  </div>
</template>

<script>
import { createReport } from "../helpers/Report";

export default {
  name: "Report",
  props: {
    entityName: {
      type: String,
      required: true
    },
    entityId: {
      type: String,
      required: true
    },
    entityValue: {
      type: String,
      required: true
    },
    side: {
      type: String,
      required: false,
      default: 'end'
    },
    iconOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonClass: {
      type: String,
      required: false,
      default: 'btn btn-link btn-sm text-danger text-decoration-none fw-bolder d-inline-flex align-items-center p-0'
    },
  },
  data() {
    return {
      id: Math.random(),
      text: '',
    }
  },
  methods: {
    createReport() {
      let data = {
        text: this.text,
        reportValue: this.entityValue
      }
      data[this.entityName] = this.entityId;

      createReport(data).then(res => {
        this.text = '';
        window.Toast.getInstance(this.$refs.report).show();
      }).catch(() => {});
    }
  },
  mounted() {
    new window.Toast(this.$refs.report);
  }
}
</script>
